export default function Home() {
  return <h1>Admin Home Page</h1>;
}